import React, { useState } from "react";
import CustomFilterHeader from "../../components/CustomFilterHeader.js";
import { Helmet } from "react-helmet";
import CustomSideBar from "../../components/CustomSideBar.js";
import { PostValues } from "../../utils/api-client.js";
import { ColumnChart } from "./columnchart.js";
import { Table, Button } from 'antd';

function updateStructure(item, index) {
  const newObj = {
    "key": index,
    "channel": item.channel,
    [item.id]: item.id,
    "netqty": item.netqty
  };
  return newObj;
}
function HabanaroSummary() {
  const [isLoading, setIsLoading] = useState(false);
  const [channelVsProfit, setChannelVsProfit] = useState([])
  const [tableData, setTableData] = useState([])
  const [columns, setColumns] = useState([]);
  let yKeys = []
  let yColumns = []
  const getSummaryData = async (
    selectedMarketplaces,
    fromDate,
    toDate
  ) => {
    setIsLoading(true);
    let requestData = {
      filters: {
        channel: { IN: selectedMarketplaces.map((mp) => mp.name) },
        fromDate: fromDate,
        toDate: toDate
      },
      "metric": {
        "ads": "withAds",
        "gst": "withGst",
        "payment": "withEstimate",
        "summarymetric": "channel"
      },
      "pagination": {
        "pageNo": 0,
        "pageSize": 50
      },
      method: "Habaneo Summary"
    };


    Promise.all([
      PostValues("getProfitability", requestData),
      PostValues("getCommonNodeApi", requestData)
    ])
      .then((results) => {
        setIsLoading(false);

        let [chartData, tableData] = results;
        if (chartData?.response?.length > 0) {
          const transformedData = chartData.response.map((item) => ({
            type: item.channel,
            sales: Number(item.profit)
          }));
          setChannelVsProfit(transformedData);
        } else {
          setChannelVsProfit([]);
        }
        if (tableData.data.length > 0) {
          const sumOfNetQty = tableData.data.reduce((sum, item) => sum + parseFloat(item.netqty) || 0, 0);
        
          const output_data = tableData.data.reduce((output, entry) => {
            const { channel, id, netqty } = entry;
            const itemId = id !== null ? id : "null";
        
            output[channel] = { ...output[channel], [itemId]: netqty };
            return output;
          }, {});
        
          const calculateTotal = (acc, channelData) => {
            Object.keys(channelData).forEach((key) => {
              if (key !== "channel") {
                acc[key] = (acc[key] || 0) + (parseInt(channelData[key]) || 0);
              }
            });
            return acc;
          };
        
          const final_output = Object.entries(output_data).map(([channel, values]) => ({
            channel,
            ...values,
            total: Object.values(values).reduce((acc, val) => acc + (parseInt(val) || 0), 0),
          }));
        
          const totals = { ...final_output.reduce(calculateTotal, {}), channel: "Total" };
        
          const percentageTotal = Object.keys(totals).reduce((percentageTotal, key) => {
            if (key !== "channel") {
              percentageTotal[key] = ((totals[key] / sumOfNetQty) * 100).toFixed(2) + " %";
            }
            return percentageTotal;
          }, { channel: "% Sold Quantity" });
        
          final_output.push(totals, percentageTotal);
        
          const dynamicColumnKeys = [...new Set(final_output.flatMap(item => Object.keys(item).filter(key => key !== 'channel' && key !== 'total')))];
        
          const xColumns = [
            {
              title: 'Channel',
              dataIndex: 'channel',
              key: 'channel',
              className: 'custom-header-cell',
              render: (text, record) => <span>{text}</span>,
            },
            ...dynamicColumnKeys.map(key => ({
              title: key,
              dataIndex: key,
              key,
              className: 'custom-header-cell',
              render: (text, record) => <span>{record[key]}</span>,
            })),
            {
              title: 'Total',
              dataIndex: 'total',
              key: 'total',
              className: 'custom-header-cell',
              render: (text, record) => <span>{text}</span>,
            },
          ];
        
          setColumns(xColumns);
          setTableData(final_output);
        } else {
          setTableData([]);
        }
        
      })
      .catch((error) => {
        console.error('One of the promises rejected:', error);
      });

  };

  const handleMarketplaceChange = async (
    selectedMarketplaces,
    fromDate,
    toDate
  ) => {
    getSummaryData(selectedMarketplaces, fromDate, toDate)
  };
  return (
    <>
      <Helmet>
        <title>{"Forcesight"}</title>
      </Helmet>
      <CustomFilterHeader
        headerTitle={"Habaneo"}
        handleMarketplaceChange={handleMarketplaceChange}
        showExportButton={false}
        showSearchBar={false}
        getExportData={false}
        columns={columns}
        searchHide={true}
        isLoading={isLoading}
        showManualSync={false}
        onFilterUpdate={(data) => {
        }}
      />
      <CustomSideBar>
        <div className="flex flex-col sm:flex-row">
          <div className="w-full sm:w-1/4 overflow-x-hidden h-400">
            <div className="border p-4 h-full">
              <h2 className="text-lg font-bold mb-4">Channel Vs Profit</h2>
              <ColumnChart channelVsProfit={channelVsProfit} isLoading={isLoading} />
            </div>
          </div>
          <div className="w-full sm:w-3/4 overflow-x-hidden h-400">
            <div className="border p-4 h-full">
              <h2 className="text-lg font-bold mb-4"></h2>
              <div style={{ overflowY: 'auto', maxHeight: '100%' }}>
                <Table
                  dataSource={tableData}
                  columns={columns}
                  size='small'
                  pagination={false}
                  scroll={{ x: 'max-content' }}
                  style={{ overflowY: 'auto', maxHeight: '100%' }}
                />
              </div>
            </div>
          </div>
        </div>

      </CustomSideBar>
    </>
  );
}
export default HabanaroSummary;
